import { cancel } from "redux-saga/effects";

export const roleAndPermissionEnum = {
  dashboard :{
    moduleKey: "dashboard",
    all: "dashboard:*",
    view: "dashboard:view",
  },

  customer:{
    moduleKey: "customer",
    all: "customer:*",
    view: "customer:view",
    block: "customer:block",
  },

  compliance :{
    moduleKey: "compliance",
    all: "compliance:*",
    complianceSubVendorView: "compliance:subVendor:view",
    complianceDriverView: "compliance:driver:view",
    complianceVehicleView: "compliance:vehicle:view",
    complianceVehicleApprove: "compliance:vehicle:approveReject",
    complianceDriverApprove: "compliance:driver:approveReject",
    complianceSubVendorApprove: "compliance:subVendor:approveReject",
  },

  reports: {
    moduleKey: "reports",
    all: "reports:*",
    view: "reports:view",
    download: "reports:download",
    subModules: {
      booking: {
        all:"*",
        moduleKey: "booking",
        view: "booking:view",
        download: "booking:download",
      },
    },
  },

  subvendor :{
    moduleKey: "subVendors",
    all: "subVendor:*",
    subVendorView: "subVendor:view",
    subVendorActivate: "subVendor:activate",
    subVendorEdit: "subVendor:edit",
    subVendorAdd: "subVendor:add",
    subVendorBlock: "subVendor:block",
    activateDriver:"subVendor:activateDriver",
    blockVehicel:"subVendor:blockVehicle",
    editVehicle:"subVendor:editVehicle",
    addVehicle:"subVendor:addVehicle",
    blockDriver:"subVendor:blockDriver",
    editDriver:"subVendor:editDriver",
    addDriver:"subVendor:addDriver",
  },

  //for testing
  subvendor2 :{
    moduleKey: "subVendors",
    all: "subVendor:*",
    subVendorView: "subVendor:view",
    subVendorActivate: "subVendor:activate",
    subVendorEdit: "subVendor:edit",
    subVendorAdd: "subVendor:add",
    subVendorBlock: "subVendor:block",
    activateDriver:"subVendor:activateDriver",
    blockVehicel:"subVendor:blockVehicle",
    editVehicle:"subVendor:editVehicle",
    addVehicle:"subVendor:addVehicle",
    blockDriver:"subVendor:blockDriver",
    editDriver:"subVendor:editDriver",
    addDriver:"subVendor:addDriver",
  },

  driver :{
    moduleKey: "ownDrivers",
    all: "driver:*",
    driverView: "driver:view",
    driverActivate: "driver:activate",
    driverEdit: "driver:edit",
    driverAdd: "driver:add",
    driverBlock: "driver:block",
  },

  driver2 :{
    moduleKey: "ownDrivers",
    all: "driver:*",
    driverView: "driver:view",
    driverActivate: "driver:activate",
    driverEdit: "driver:edit",
    driverAdd: "driver:add",
    driverBlock: "driver:block",
  },

  vehicle :{
    moduleKey: "vehicle",
    all: "vehicle:*",
    vehicleView: "vehicles:view",
    vehicleEdit: "vehicles:edit",
    vehicleAdd: "vehicles:add",
    vehicleBlock: "vehicles:block",
  },

  citymanager :{
    moduleKey: "cityManager",
    all: "cityManager:*",
    view: "cityManager:view",
    add: "cityManager:add",
  },

  trackTrip :{
    moduleKey: "trackTrip",
    all: "trackTrip:*",
    view: "trackTrip:view",
    cancel: "trackTrip:cancel",
  },

  invoice :{
    moduleKey: "invoice",
    all: "invoice:*",
    view: "invoice:view",
    download: "invoice:download",
  },

  configuration: {
    moduleKey: "configuration",
    all: "configuration:*",
    subModules: {
    feedback: {
        moduleKey: "configFeedback",
        all:"configFeedback:*",
        view: "configFeedback:view",
        edit: "configFeedback:edit",
        add: "configFeedback:add",
      },
      compliance: {
        moduleKey: "compliance",
        all:"configCompliance:*",
        view: "configCompliance:view",
        edit: "configCompliance:edit",
        add:"configCompliance:add",
      },
      vehicleCategory: {
        moduleKey: "vehicleCategory",
        all:"vehicleCategory:*",
        view: "vehicleCategory:view",
        edit: "vehicleCategory:edit",
        add:"vehicleCategory:add",
      },
      faq: {
        moduleKey: "faq",
        all:"faq:*",
        view: "faq:view",
        edit: "faq:edit",
        add:"faq:add",
      },
      coupon: {
        moduleKey: "coupon",
        all:"coupon:*",
        view: "coupon:view",
        edit: "coupon:edit",
        add:"coupon:add",
        delete:"coupon:delete",
      },
    },
  },

  assign: {
    moduleKey: "assign",
    all: "assign:*",
    subModules: {
      assignDriver: {
        moduleKey: "assignDriver",
        all:"allotDriver:*",
        view: "allotDriver:view",
        allot: "allotDriver:assign",
      },
      assignVehicle: {
        moduleKey: "assignVehicle",
        all:"allotVehicle:*",
        view: "allotVehicle:view",
        allot: "allotVehicle:assign",
      },
      assignTrip: {
        moduleKey: "allRides",
        all:"allRides:*",
        view: "allRides:view",
        allot: "allRides:allot",
        cancel: "allRides:cancel",
      },
    },
  },
};